import Script from 'react-load-script';
import React from 'react';

// Added Khoros script(GOTOCOM-4003) just for the Review env. Prod should see BoldChat
const handleScriptLoad = () => {
    // set var so script doesn't load twice
    window.qualifiedLoaded = true;
};

const QualifiedChat = () => {
    /* eslint-disable */
    if (window.qualifiedLoaded) return false;

    return (
        <Script
            url={`https://js.qualified.com/qualified.js?token=6jsAF8Y9Q11eF2PQ`}
            async
            onLoad={handleScriptLoad}
        />
    )
}

export default QualifiedChat
